import { handleValueOrFn as origHandleValueOrFn } from './utils/handleValueOrFn';

/**
 * @deprecated - Use `handleValueOrFn` from `@clerk/shared/utils` instead.
 */
export const handleValueOrFn = origHandleValueOrFn;
